import { hasTargetThatCanBeDisabled } from '../../../common/utils/event-typeguards';
import { ErpAdditionalMessageDto } from './../../../common/model/erpadditionalmessagedto';
import { JobApplication } from 'app/rm/erp/jobapplication/model/jobapplication';
import { JobApplicationAndDocuments } from './../../model/jobapplicationanddocuments';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Field } from 'app/rm/erp/jobapplication/model/bwmconfig';
import { JobApplicationService } from '../../service/jobapplication.service';
import { HisNotificationService, HisUiService } from 'hisng';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Active } from 'app/rm/erp/jobapplication/model/bwmconfig';

@Component( {
    selector: 'erp-jobapplication-overview',
    templateUrl: './jobapplication-overview.component.html',
} )
export class JobApplicationOverviewComponent implements OnInit {

    @Input() jobApplication: JobApplicationAndDocuments = new JobApplicationAndDocuments();
    @Output() readonly onJobApplicationSent = new EventEmitter<ErpAdditionalMessageDto<JobApplication>>();
    @Output() readonly onBackToJobApplicationForm = new EventEmitter<never>();

    displayPrivacyPolicy = false;
    privacyPolicyUrl: SafeResourceUrl;
    fields: Field[] = [];

    constructor(
        private readonly jobApplicationService: JobApplicationService,
        private readonly notificationService: HisNotificationService,
        private readonly hisUiService: HisUiService,
        private readonly dom: DomSanitizer
    ) {
        this.privacyPolicyUrl = this.dom.bypassSecurityTrustResourceUrl(
            this.hisUiService.translate( 'rm.erp.jobapplication.JobApplication.privacypolicyUrl' ) );
    }

    ngOnInit() {
        // Ermittlung aller aktiven Felder, um im Template die Felder in der Reihenfolge ihrer Definition darzustellen
        if ( this.jobApplication.application.jobAdvertisementId ) {
            this.jobApplicationService.getJobApplicationConfig( this.jobApplication.application.jobAdvertisementId )
                .subscribe( bwmConfig => {
                    bwmConfig.categories.forEach( ( category ) => {
                        if ( category.active === Active.Y && category.fields != null ) {
                            category.fields.forEach( field => {
                                if ( field.active === Active.Y ) {
                                    this.fields.push( field );
                                }
                            } );
                        }
                    } );
                } );
        }
    }

    createJobApplication( event: UIEvent ) {
        // Der Button soll deaktiviert werden, bis das Senden an das Backend abgeschlossen ist.
        if ( hasTargetThatCanBeDisabled( event ) ) {
            event.target.disabled = true;
            this.notificationService.clear();

            if ( !this.jobApplication.privacyPolicyAccepted ) {
                this.showErrorMessage( 'rm.erp.jobapplication.overview.error.privacypolicymissing' );
                event.target.disabled = false;
            } else {
                this.jobApplicationService.createJobApplication( this.jobApplication ).subscribe({
                    next: (createdJobApplication) => {
                        if ( createdJobApplication.dto.id ) {
                            this.notificationService.success(
                                this.hisUiService.translate( 'rm.erp.jobapplication.application.save.success' ),
                                this.hisUiService.translate( 'view.messages.success' ), 5000 );
                            event.target.disabled = false;
                            this.onJobApplicationSent.emit( createdJobApplication );
                        } else {
                            event.target.disabled = false;
                        }
                    },
                    error: () => {
                        event.target.disabled = false;
                    }
                });
            };
        }
    }

    backToJobApplicationForm() {
        this.onBackToJobApplicationForm.emit();
    }

    /* error message */
    showErrorMessage( messageKey: string ): void {
        this.notificationService.error(
            this.hisUiService.translate( messageKey ),
            this.hisUiService.translate( 'fs.res.common.service.error' ), 5000
        );
    }
}
